<!-- @veltra/icons generated sha256:7873be5667bf804c gen:8 source:src/svg/normal/relativity.svg -->
<script setup lang="ts">
defineOptions({ name: 'Relativity' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M5.5 5.5v-3a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-3v3a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1zm1-3h7v7h-3v-3a1 1 0 0 0-1-1h-3zm3 8v3h-7v-7h3v3a1 1 0 0 0 1 1zm0-1h-3v-3h3z"
    />
  </svg>
</template>
